<template>
  <div class="container">
    <h5>您当前所在位置： 首页 >> 岗位名称 >> {{JobRequest.JOBNAME}}</h5>

    <div class="gangwei-con">
      <!-- 岗位标题 -->
      <div class="gangwei-title">
        <span>{{JobRequest.JOBNAME}}</span>
        <span class="applys" href="javascript:;" @click="sq">立即申请</span>
      </div>
      <!-- 岗位要求 -->
      <div class="detail">
        <ul>
          <li>工作地点：{{JobRequest.WORKAREA}}</li>
          <li>发布日期：{{JobRequest.PUBTIME}}</li>
          <li>用人单位：{{JobRequest.DEPTNAME}}</li>
          <li>所需专业：{{JobRequest.JOBREQUIRE_PROFESSION}}</li>
          <li>学历要求：{{JobRequest.JOBREQUIRE_DEGREE}}</li>
          <li>招聘人数：{{JobRequest.JOBREQUIRE_NUMBER}}</li>
        </ul>
      </div>
      <!-- 单位简介 -->
      <div class="describe">
        <h4>
          <span>单位简介</span>
        </h4>
        <div class="describe-menu">
          <ul>
            <li><p>{{JobRequest.DEPTDESC}}</p></li>
          </ul>
        </div>
      </div>
       <!-- 岗位描述 -->
      <div class="describe">
        <h4>
          <span>职位描述</span>
        </h4>
        <div class="describe-menu">
          <ul>
            <li><p v-html="JobRequest.JOBDESC"></p></li>
          </ul>
        </div>
      </div>
    </div>


  <gwbb :visible.sync="visible" :gwbbData="gwbbData" :ksplace="ksplace"></gwbb>

  </div>
</template>





<script>
import gwbb from '../../zkzw/compos/gwbb.vue'
export default {
  components:{
    gwbb
  },
  data(){
    return{
      //工作要求
      JobRequest:{},

      //岗位补报
      visible:false,

      //头像信息
        a01109:'',

         //获取已投递简历的数据
        jldata:[],


       // 传给对话框的数据
      gwbbData:{},

      ksplace:[],
    }
  },

  created(){
    this.jobDetail()
  },

  methods:{
    // 打开加载岗位详情
    jobDetail(id){
      this.post({
        url:'jobDetail',
        data:{
          jobID:id
        }
      },(res)=>{
        if(res.code=200){
          this.JobRequest=res.data.joblist[0]
          console.log(this.JobRequest);
        }
      })
    },
    //申请
    sq(){
       console.log(this.JobRequest);
      if(!sessionStorage.getItem('BDSOFT-TOKEN')) return this.$message.warning('请先登录')

      if(!this.a01109) return this.$message.error('请先上传照片')

      // var issq = this.jldata.some(i => {
      //   return i.JOBID===r.JOBID
      // });
      // if(issq) return this.$message.error('您已经申请过该职位了')

      // var ispcsq = this.jldata.some(i => {
      //   return i.BATCHID===r.BATCHID
      // });
      // if(ispcsq) return this.$message.error('您已超过当前批次申报数，无法再申报')

      this.post({
        url: 'allowApplyNum',
        data: {
          A00: sessionStorage.getItem('aabb'),
          BATCHID: this.JobRequest.BATCHID,
          JOBID: this.JobRequest.JOBID,
        }
      },(res)=>{
        console.log(res);
        if(res.message=="正常填报！"){
          this.gwbbData=this.JobRequest

          this.get({
            url:'getPlaceid',
            data:{
              batchid:this.JobRequest.BATCHID
            }
          },(res)=>{
            console.log(res);
            console.log(999);
            if(res.code==200){
              this.ksplace=res.data
            }
          })

          this.visible=true
        }else if(res.message=="已申请过该职位，不能重复申请！"){
          this.$message.error(res.message)
        } else{
          this.$message.error(res.message)
        }
      })
    },

    //获取个人简历的照片信息
    //获取个人简历信息
    getBasicInfo(){
      this.post({
        url:'getBasicInfo',
        data:{
          a00:sessionStorage.getItem('aabb'),
        }
      },(res)=>{
        this.a01109 = res.data.zdyxa0106
        
      })
    },


    //获取已申请过的列表
    deliveryProgress(){
      this.post({
          url: 'deliveryProgress',
      }, (res) => {
        console.log(555);
        console.log(res);
        this.jldata=res.data
      })
    },
  },

  created(){
     this.jobDetail(this.$route.query.jobID)
     this.getBasicInfo()
     this.deliveryProgress()
  }
}
</script>




<style scoped>
li{
  list-style: none;
}
.container{
    width: 1000px;
    margin: 0 auto;
    min-height: 100px;
    margin-top: 15px;
    margin-bottom: 45px;
    background-color: #e3eeff;
}

h5{
  height: 30px;
  line-height: 30px;
  border-bottom: 2px solid #c00000;
  font-size: 14px;
  color: #6e6e6e;
  padding-left: 20px;
}
.gangwei-con{
  position: relative;
}
.gangwei-title{
    height: 88px;
    background-color: #fff;
    border-bottom: 2px solid #b9cce9;
    position: relative;
}
.gangwei-title span {
    font-size: 18px;
    color: #000;
    line-height: 88px;
    margin-left: 14px;
}
.gangwei-title .applys {
    display: inline-block;
    width: 141px;
    height: 35px;
    line-height: 32px;
    background-color: #F1A338;
    text-align: center;
    font-size: 14px;
    color: #fff;
    position: absolute;
    right: 16px;
    top: 26px;
    border-radius: 3px;
    box-shadow: 0px 3px  #B57100;
}

.detail{
  padding: 20px 30px;
  height: 142px;
}
.detail li {
    width: 45%;
    float: left;
    color: #000;
    font-size: 14px;
    line-height: 34px;
}
.describe{
  padding:10px 20px 30px 20px ;
}
h4{
    height: 32px;
    background-color: #fff9f1;
    border-bottom: 1px solid #f6a639;
}
h4 span{
    font-size: 14px;
    color: #fff;
    background-color: #f6a639;
    width: 110px;
    height: 32px;
    display: block;
    text-align: center;
    line-height: 32px;
}
.describe-menu{
  line-height: 30px;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/views/sy/pages/gw.vue